module.exports = __webpack_public_path__ + "img/67.aa6d7985.png";